export const AuthFormTranslationsCs = {
  placeholderLogin: 'Email / Telefonní číslo',
  description:
    'Autorizujte se pomocí svého přihlašovacího údaje (zadejte telefonní číslo nebo e-mail)',
  login: 'Přihlášení',
  password: 'Heslo',
  passwordPlaceholder: '****',
  forgotPassword: 'Zapomněl(a) jsem své heslo',
  submitButton: 'Přihlásit se',

  // error
  'Required field': 'Povinné pole',
  validLogin:
    'Zadejte platné přihlašovací údaje (e-mail nebo platné telefonní číslo)',

  // errors back-end
  'login or password is wrong': 'Přihlašovací jméno nebo heslo je nesprávné',
};
